import { Navigate, Route, Routes } from "react-router-dom";
import { DashboardLayout } from "@/pages/dashboard/DashboardLayout";
import { DashboardHomePage } from "@/pages/dashboard/DashboardHomePage";
import { GuidesPage } from "@/pages/dashboard/guides/GuidesPage";
import { ChaptersPage } from "@/pages/dashboard/chapters/ChaptersPage";
import { PagesListPage } from "@/pages/dashboard/pages/PagesListPage";
import { NewPagePage } from "@/pages/dashboard/pages/NewPagePage";
import { PageDetailPage } from "@/pages/dashboard/pages/PageDetailPage";
import { PagePreviewPage } from "@/pages/dashboard/pages/PagePreviewPage";
import { ApprovalsPage } from "@/pages/dashboard/approvals/ApprovalsPage";
import { LoginPage } from "@/pages/login/LoginPage";

export function App() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<DashboardLayout />}>
        <Route index element={<DashboardHomePage />} />
        <Route path="guides" element={<GuidesPage />} />
        <Route path="chapters" element={<ChaptersPage />} />
        <Route path="pages" element={<PagesListPage />} />
        <Route path="pages/new" element={<NewPagePage />} />
        <Route path="pages/:id" element={<PageDetailPage />} />
        <Route path="pages/:id/preview" element={<PagePreviewPage />} />
        <Route path="approvals" element={<ApprovalsPage />} />
        <Route path="profile" element={<Navigate to="/dashboard" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
